import { getModalByTemplate } from "../modal";

let modalOpenBtn = document.querySelector("button[data-action='modal-test-guide']")

if(modalOpenBtn) {
    modalOpenBtn.addEventListener("click", function () {
        getModalByTemplate("generic-error", {
            title: "Modal Guide",
            description: "Modal Guide description",
        });
    })
}
